import ResponsivePage from './ResponsivePage'


export default ResponsivePage
